import React, { useRef, useState } from 'react';
import { Typography } from '@shared/ui/typography/typography';
import { Button } from '@vtbhome/juicyfront';
import { FilterProps } from './types';
import { DropdownHead, FiltersHead, Fitlers, StyledMenu } from './filter.styles';
import { TuneUp } from '@vtbhome/juicyfront/indexIcon';
import { useOutsideClick } from '@shared/lib/hooks/use-click-outside/use-click-outside';

export const Filter: React.FC<FilterProps> = ({ menuTitle = 'Фильтры', children, onResetAllFilters }) => {
    const [isShow, setIsShow] = useState(false);
    const parentRef = useOutsideClick<HTMLDivElement>({ callback: () => setIsShow(false) });
    const containerRef = useRef<HTMLDivElement>(null);

    return (
        <div ref={parentRef} data-test={'parent for filter'}>
            <StyledMenu
                position='bottom-end'
                containerRef={containerRef}
                content={
                    <Fitlers>
                        <FiltersHead>
                            <Typography size='subtitle2'>{menuTitle}</Typography>
                            <Button size='s' buttonType='ghost' onClick={() => onResetAllFilters()}>
                                Очистить все
                            </Button>
                        </FiltersHead>
                        {children}
                    </Fitlers>
                }>
                <DropdownHead $isShowMenu={isShow} onClick={() => setIsShow(!isShow)}>
                    <TuneUp />
                </DropdownHead>
            </StyledMenu>
            <div ref={containerRef} data-test={'container for filter'} />
        </div>
    );
};
